import { useEffect } from 'react'

import { categoryNameFromDom } from '../DomUtils/categoryNameFromDom'
import { asSelectors, ClassNames } from '../DomUtils/classNames'
import { useBodyRef } from '../components/context/ElementRefContext'

export function useActiveCategoryScrollDetection(
  activeCategory: string,
  setActiveCategory: (category: string) => void,
) {
  const BodyRef = useBodyRef()

  useEffect(() => {
    const visibleCategories = new Map()
    const bodyRef = BodyRef.current
    const observer = new IntersectionObserver(
      (entries) => {
        if (!bodyRef) {
          return
        }

        if (!activeCategory) return setActiveCategory('suggested')

        for (const entry of entries) {
          const id = categoryNameFromDom(entry.target)
          visibleCategories.set(id, entry.intersectionRatio)
        }

        const ratios = Array.from(visibleCategories)
        const lastCategory = ratios[ratios.length - 1]

        if (lastCategory[1] == 1) {
          // eslint-disable-next-line
          return setActiveCategory(lastCategory[0])
        }

        const visibleArr = ratios.filter((c) => c[1])
        const isSingleCategoryVisible = visibleArr.length === 1

        for (const [id, ratio] of ratios) {
          if (
            ratio > 0.099 ||
            (ratio && isSingleCategoryVisible && visibleArr[0][0] === id)
          ) {
            setActiveCategory(id as string)
            break
          }
        }
      },
      {
        threshold: [0, 0.1],
      },
    )
    const elements = bodyRef?.querySelectorAll(asSelectors(ClassNames.category))
    elements?.forEach((el) => {
      observer.observe(el)
    })
  }, [BodyRef, setActiveCategory, activeCategory])
}
